import React, { useEffect, useState } from "react";
import ReactGA from "react-ga";
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from "react-router-dom";

import CssBaseline from "@mui/material/CssBaseline";
import {
  ThemeProvider,
  StyledEngineProvider,
  createTheme,
  adaptV4Theme,
} from "@mui/material/styles";

import "./App.css";
import Dashboard from "./components/Dashboard/Dashboard";
import LandingPage from "./components/LandingPage/LandingPage";
import firebase from "./firebase";
import LanguageContext from "./LanguageContext";
import UserService from "./services/UserService";

import StateService from "./services/StateService";
import Signup from "./components/Signup/Signup";
import CropPage from "./components/CropPage/CropPage";
import ReferenceDataService from "./services/ReferenceDataService";
import FreeContainer from "./components/Signup/FreeContainer";
import YoutubeDialog from "./components/YouTubeDialog";
import VideoDialog from "./components/VideoDialog";
import MeetingsList from "./components/MeetingsList/MeetingsList";
import ContentVideoDialog from "./components/ContentVideoDialog";
import CropVideosPage from "./components/CropPage/CropVideosPage";

ReactGA.initialize("UA-177625484-1");
ReactGA.pageview(window.location.pathname + window.location.search);

firebase.analytics();
firebase.performance();

const theme = createTheme({
  palette: {
    primary: {
      main: "#9D2123",
    },
    secondary: {
      main: "#00733E",
    },
    error: {
      main: "#FF0000",
    },
    standard: {
      main: "#FFFFFF",
    },
  },
});

function App() {
  let [userState, setUserState] = useState(null);
  let [crops, setCrops] = useState([]);
  let [states, setStates] = useState([]);
  let [stages, setStages] = useState([]);
  let [languages, setLanguages] = useState([]);
  let [userLanguage, setUserLanguage] = useState({});
  let [authors, setAuthors] = useState([]);
  let [packages, setPackages] = useState([]);
  let [referenceData, setReferenceData] = useState({});
  let [loadingMasterData, setLoadingMasterData] = useState("not-started");

  const changeUserState = (userState) => {
    setUserState(userState);
  };
  const changeUserLanguage = (userLanguage) => {
    setUserLanguage(userLanguage);
  };

  useEffect(() => {
    setLoadingMasterData("started");
    let loadData = async () => {
      ReferenceDataService.getAllReferenceData().then((responnse) => {
        let refData = responnse.data;
        if (refData) {
          setReferenceData(refData);

          if (refData.crops) {
            setCrops(refData.crops);
          }
          if (refData.languages) {
            setLanguages(refData.languages);
          }
          if (refData.packages) {
            setPackages(refData.packages);
          }
          if (refData.authors) {
            setAuthors(refData.authors);
          }
          if (refData.states) {
            setStates(refData.states);
          }
          if (refData.stages) {
            setStages(refData.stages);
          }

          let stateNameFromGeoAPI = "maharashtra";

          let userStateDetected = StateService.getStateByName(
            refData.states,
            stateNameFromGeoAPI
          );

          setUserState(userStateDetected);
          if (userStateDetected) {
            if (userStateDetected.language) {
              setUserLanguage(userStateDetected.language);
            }
          } else {
          }
          setLoadingMasterData("done");
        }
      });
    };

    loadData().then(() => {});
  }, []);

  function PrivateRoute({ children, ...rest }) {
    return (
      <Route
        {...rest}
        render={({ location }) => {
          return UserService.checkUserLogin() ? (
            children
          ) : (
            <Redirect
              to={{
                pathname: "/",
                state: { from: location },
              }}
            />
          );
        }}
      />
    );
  }

  return (
    <div className="App">
      <CssBaseline />
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <LanguageContext.Provider
            value={userLanguage.code ? userLanguage.code : "mr"}
          >
            <Router>
              <Switch>
                <Route exact path="/">
                  <LandingPage
                    crops={crops}
                    changeUserLanguage={changeUserLanguage}
                    paymentPackage={packages[0]}
                    userState={userState}
                    states={states}
                    // languages={languages}
                    // authors={authors}
                    // changeUserState={changeUserState}
                  />
                </Route>
                <Route exact path="/login">
                  <FreeContainer
                    userState={userState}
                    loading={loadingMasterData}
                    paymentPackage={packages[0]}
                    changeUserLanguage={changeUserLanguage}
                    states={states}
                    languages={languages}
                  />
                </Route>
                {/*<Route exact path="/join">*/}
                {/*  <Signup*/}
                {/*    userState={userState}*/}
                {/*    loading={loadingMasterData}*/}
                {/*    paymentPackage={packages[0]}*/}
                {/*    states={states}*/}
                {/*  />*/}
                {/*</Route>*/}
                <Route exact path="/join">
                  <FreeContainer
                    userState={userState}
                    loading={loadingMasterData}
                    paymentPackage={packages[0]}
                    changeUserLanguage={changeUserLanguage}
                    states={states}
                  />
                </Route>
                <Route exact path="/free">
                  <FreeContainer
                    userState={userState}
                    loading={loadingMasterData}
                    paymentPackage={packages[0]}
                    changeUserLanguage={changeUserLanguage}
                    states={states}
                  />
                </Route>
                <Route exact path="/join/:mode/:mobile">
                  <Signup
                    loading={loadingMasterData}
                    paymentPackage={packages[0]}
                    states={states}
                  />
                </Route>
                <Route exact path="/crop/:crop">
                  <CropPage
                    referenceData={referenceData}
                    loadingMasterData={loadingMasterData}
                    changeUserLanguage={changeUserLanguage}
                  />
                </Route>
                <Route exact path="/crop-videos/:crop">
                  <CropVideosPage
                    referenceData={referenceData}
                    loadingMasterData={loadingMasterData}
                    changeUserLanguage={changeUserLanguage}
                  />
                </Route>

                <PrivateRoute path="/dashboard">
                  <Dashboard
                    referenceData={referenceData}
                    loadingMasterData={loadingMasterData}
                    changeUserLanguage={changeUserLanguage}
                  />
                </PrivateRoute>
                <Route exact path="/crop/:crop/content/:youtube_id">
                  <YoutubeDialog />
                </Route>
                <Route exact path="/crop-videos/:crop/content/:youtube_id">
                  <YoutubeDialog />
                </Route>
                <Route exact path="/crop/:crop/video/:youtube_id">
                  <ContentVideoDialog
                    referenceData={referenceData}
                    loadingMasterData={loadingMasterData}
                    changeUserLanguage={changeUserLanguage}
                  />
                </Route>
                <PrivateRoute exact path="/crop/:crop/recordings/:id">
                  <VideoDialog />
                </PrivateRoute>
                <Route exact path="/meetings">
                  <MeetingsList
                    referenceData={referenceData}
                    loadingMasterData={loadingMasterData}
                    changeUserLanguage={changeUserLanguage}
                  />
                </Route>
                <Route exact path="/meetings/:crop">
                  <MeetingsList
                    referenceData={referenceData}
                    loadingMasterData={loadingMasterData}
                    changeUserLanguage={changeUserLanguage}
                  />
                </Route>
              </Switch>
            </Router>
          </LanguageContext.Provider>
        </ThemeProvider>
      </StyledEngineProvider>
    </div>
  );
}

export default App;
